import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Button, Header, Icon, Modal } from 'semantic-ui-react'
import { useAppDispatch, useAppSelector } from '../../common/store'
import {
  PLACENAME_LOCATION_NOT_AVAILABLE_MESSAGE_1,
  PLACENAME_LOCATION_NOT_AVAILABLE_MESSAGE_2,
  PLACENAME_LOCATION_NOT_AVAILABLE_TITLE,
  RECAPTCHA_ENABLED,
} from '../../environment'

import VctRecaptcha from '../vct-recaptcha/VctRecaptcha'
import PlacenameDetails from './PlacenameDetails'
import './PlacenamesSearch.css'
import PlacenamesSearchBar from './PlacenamesSearchBar'
import { getPlacenameData, PlacenameDataType, selectPlacenameParcel } from './slice'

interface MatchParams {
  placeId: string
}

interface MatchProps extends RouteComponentProps<MatchParams> {
}

function PlacenamesSearch({ match }: MatchProps) {
  const [openAlert, setOpenAlert] = useState(false)
  const placenameData = useAppSelector(getPlacenameData)
  const dispatch = useAppDispatch()
  const placeId = match?.params.placeId

  function shouldRenderPlacenameData() {
    return !_.isEmpty(placenameData)
  }

  function hasAltGeometry(data: PlacenameDataType) {
    return data.altGeometry && data.altGeometry.length > 0 && data.altGeometry[0]
  }

  useEffect(() => {
    if (shouldRenderPlacenameData()) {
      if ((placenameData?.latitude == null || placenameData!.longitude == null) && !(hasAltGeometry(placenameData!))) {
        setOpenAlert(true)
      }
    }
    return (() => {
      setOpenAlert(false)
    })

  }, [placenameData])

  useEffect(() => {
    if (placeId && (_.isEmpty(placenameData) || placenameData && placenameData.placeId !== placeId)) {
      dispatch(selectPlacenameParcel(placeId))
    }
  }, [match])

  return (
    <div id="placenamesSearchView">
      <PlacenamesSearchBar/>
      {/* Parcel Details are only rendered when valuation data is received from the redux store.  */}
      {shouldRenderPlacenameData() && placenameData && <PlacenameDetails placenameData={placenameData}/>}
      {RECAPTCHA_ENABLED && <VctRecaptcha/>}
      {shouldRenderPlacenameData() &&
          <Modal open={openAlert} size="tiny">
              <Header>
                  <Icon name="map marker alternate" size="small"/>
                {PLACENAME_LOCATION_NOT_AVAILABLE_TITLE}
              </Header>
              <Modal.Content>
                  <p> {PLACENAME_LOCATION_NOT_AVAILABLE_MESSAGE_1}
                      <b>{placenameData!.officialName} ({placenameData!.typeDesignation})</b> {PLACENAME_LOCATION_NOT_AVAILABLE_MESSAGE_2}
                  </p>
              </Modal.Content>
              <Modal.Actions>
                  <Button primary onClick={() => setOpenAlert(false)}>
                      Ok
                  </Button>
              </Modal.Actions>
          </Modal>}
    </div>
  )
}

export default PlacenamesSearch
